import * as api from '../resources/admin-reports.api';
import actionTypes from './action-types';

export const fetchUserActivityReportsRequest = () => ({
  type: actionTypes.FETCH_USER_ACTIVITY_REPORTS_REQUEST,
  name: 'userActivityReportsLoadingStatus',
});

export const fetchUserActivityReportsFailure = () => ({
  type: actionTypes.FETCH_USER_ACTIVITY_REPORTS_FAILURE,
  name: 'userActivityReportsLoadingStatus',
});

export const fetchUserActivityReportsSuccess = (items, pagination) => ({
  type: actionTypes.FETCH_USER_ACTIVITY_REPORTS_SUCCESS,
  items,
  pagination,
  name: 'userActivityReportsLoadingStatus',
});

export const fetchUserActivityReports = (parameters) => async (dispatch) => {
  try {
    dispatch(fetchUserActivityReportsRequest());
    const { content, ...pagination } = await api.fetchActivityReport(parameters);
    dispatch(fetchUserActivityReportsSuccess(content, pagination));
  } catch (error) {
    dispatch(fetchUserActivityReportsFailure());
    console.error('FETCH_USER_ACTIVITY_REPORTS_FAILURE', error);
  }
};

export const downloadUserActivityReportsRequest = () => ({
  type: actionTypes.DOWNLOAD_USER_ACTIVITY_REPORTS_REQUEST,
});

export const downloadUserActivityReportsSuccess = () => ({
  type: actionTypes.DOWNLOAD_USER_ACTIVITY_REPORTS_SUCCESS,
});

export const downloadUserActivityReportsFailure = () => ({
  type: actionTypes.DOWNLOAD_USER_ACTIVITY_REPORTS_FAILURE,
});

export const downloadActivityReports = (extension, params) => (dispatch) => {
  try {
    const config = {
      extension,
      ...params,
    };
    dispatch(downloadUserActivityReportsRequest());
    dispatch(downloadUserActivityReportsSuccess());
    return api.downloadActivityReports(config);
  } catch (error) {
    console.error('DOWNLOAD_ACTIVITY_REPORT', error);
    dispatch(downloadUserActivityReportsFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/admin-reports/actions/admin-reports.actions.js